if (!customElements.get('product-customization')) {
  customElements.define(
    'product-customization',
    class ProductCustomization extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.fieldset = this.querySelector('fieldset');
        if (!this.fieldset || this.inputs.length === 0) return;

        this.initialized = true;
        this.scope = this.closest('product-info') || document;
        this.form = this.scope.querySelector('form[data-type="add-to-cart-form"]');
        this.buttons = this.scope.querySelector('.product-form__buttons');

        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.onOptionChange = this.onOptionChange.bind(this);
        this.updateDynamicCheckout = this.updateDynamicCheckout.bind(this);

        // Bound on an ancestor in the capture phase so it always runs before the
        // listener product-form.js binds directly to the form, regardless of the
        // order the two custom elements upgrade in.
        this.scope.addEventListener('submit', this.onFormSubmit, true);
        this.addEventListener('change', this.onOptionChange);

        // The dynamic checkout button is injected by Shopify after page load, so
        // watch for it rather than assuming it is present now.
        if (this.buttons) {
          this.paymentButtonObserver = new MutationObserver(this.updateDynamicCheckout);
          this.paymentButtonObserver.observe(this.buttons, { childList: true, subtree: true });
        }

        this.updateDynamicCheckout();
      }

      disconnectedCallback() {
        this.scope?.removeEventListener('submit', this.onFormSubmit, true);
        this.paymentButtonObserver?.disconnect();
        this.initialized = false;
      }

      get inputs() {
        return this.querySelectorAll('input[type="radio"]');
      }

      get selectedValue() {
        return Array.from(this.inputs).find((input) => input.checked)?.value || '';
      }

      onFormSubmit(event) {
        if (event.target !== this.form || this.selectedValue) return;

        event.preventDefault();
        event.stopPropagation();

        this.fieldset.setAttribute('aria-invalid', 'true');
        this.toggleError(this.dataset.errorMessage);
        this.inputs[0].focus({ preventScroll: true });
        this.fieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      onOptionChange() {
        if (this.selectedValue) {
          this.fieldset.removeAttribute('aria-invalid');
          this.toggleError(false);
        }

        this.updateDynamicCheckout();
      }

      // Mirrors ProductForm.handleErrorMessage so the same wrapper is reused, but
      // without depending on that element having upgraded yet.
      toggleError(message) {
        const wrapper = this.scope.querySelector('.product-form__error-message-wrapper');
        if (!wrapper) return;

        wrapper.toggleAttribute('hidden', !message);
        if (message) wrapper.querySelector('.product-form__error-message').textContent = message;
      }

      // 'Buy it now' bypasses product-form.js entirely, so it cannot be validated
      // on submit — it is disabled until a customization is chosen instead.
      updateDynamicCheckout() {
        if (!this.buttons) return;

        const blocked = !this.selectedValue;
        this.buttons.toggleAttribute('data-customization-blocked', blocked);
        this.buttons.querySelector('.shopify-payment-button')?.toggleAttribute('inert', blocked);
      }
    }
  );
}
